import React from 'react';
import './Footer.css';
import { useSectionView } from '../hooks/useSectionView';
import { sendEvent } from '../analytics';

const Footer = () => {
  const scrollToTop = () => {
    const homepageContainer = document.querySelector('.homepage-container');
    if (homepageContainer) {
      homepageContainer.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Fallback to window scroll if homepage container not found
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const featuresSection = document.querySelector('.features-section');
    if (featuresSection) {
      featuresSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTeam = () => {
    const teamSection = document.querySelector('.team-section');
    if (teamSection) {
      teamSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToProjects = () => {
    const ctaSection = document.querySelector('.cta-section');
    if (ctaSection) {
      ctaSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const contactSection = document.querySelector('.contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer-section" className="footer-section">
      {useSectionView('footer', 'footer-section')}
      <div className="footer-curve-background">
        <svg className="footer-curve" width="1225" height="635" viewBox="0 0 1225 635" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M-246.491 645C-256.703 535.795 -214.912 424.09 -126.402 324.012C-37.8915 223.933 93.362 139.977 250.761 82.7579C408.16 25.5393 584.636 -2.37113 757.871 2.55603C931.106 7.48319 1093.32 45.0266 1224 110.439" stroke="url(#paint0_linear_footer)" strokeWidth="4"/>
          <defs>
            <linearGradient id="paint0_linear_footer" x1="1010.5" y1="-16.5" x2="150.2" y2="-408.452" gradientUnits="userSpaceOnUse">
              <stop stopColor="#1F2023"/>
              <stop offset="0.305824" stopColor="#FF7557"/>
              <stop offset="0.539613" stopColor="#DE35FF"/>
              <stop offset="0.704599" stopColor="#173EFF"/>
              <stop offset="1" stopColor="#16F1FF"/>
            </linearGradient>
          </defs>
        </svg>
      </div>

      <nav className="footer-navigation">
        <div className="footer-nav-item bordered" onClick={() => { try { sendEvent('click_nav', { item_id: 'home', menu: 'footer' }); } catch (_) {} scrollToTop(); }}>Home</div>
        <div className="footer-nav-item bordered" onClick={() => { try { sendEvent('click_nav', { item_id: 'services', menu: 'footer' }); } catch (_) {} scrollToServices(); }}>Services</div>
        <div className="footer-nav-item bordered" onClick={() => { try { sendEvent('click_nav', { item_id: 'over_ons', menu: 'footer' }); } catch (_) {} scrollToTeam(); }}>Over ons</div>
        <div className="footer-nav-item bordered" onClick={() => { try { sendEvent('click_nav', { item_id: 'projecten', menu: 'footer' }); } catch (_) {} scrollToProjects(); }}>Projecten</div>
        <div className="footer-nav-item bordered" onClick={() => { try { sendEvent('click_nav', { item_id: 'contact', menu: 'footer' }); } catch (_) {} scrollToContact(); }}>Contact</div>
      </nav>

      <div className="footer-logo">
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="15" r="13" stroke="url(#paint0_linear_footer_logo)" strokeWidth="4"/>
          <defs>
            <linearGradient id="paint0_linear_footer_logo" x1="5.85" y1="2.85" x2="24.45" y2="27.75" gradientUnits="userSpaceOnUse">
              <stop stopColor="#FF7557"/>
              <stop offset="0.5" stopColor="#173EFF"/>
              <stop offset="1" stopColor="#16F1FF"/>
            </linearGradient>
          </defs>
        </svg>
        <span className="footer-logo-text">Waardewerkers Advies</span>
      </div>

      <div className="footer-description">
        Planologie, gebiedseconomie, rekenmodellen en data. Waardewerkers biedt Professionele adviesdiensten voor duurzame ruimtelijke ontwikkeling.
      </div>

      <div className="footer-copyright">
        © Waardewerkers advies 2025
      </div>
    </footer>
  );
};

export default Footer;
